export const MOBILE_DEVICE = 'mobile'
